import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'

export default function useDepositsList() {
    const toast = useToast()
    const records = ref(null)

    // Table Handler
    const columns = [
        { key: 'id', label: '', sortable: false, thStyle: 'width:40px; min-width:40px' },
        { key: 'name', label: 'Beneficiary', sortable: false },
        { key: 'market', label: 'Market Center', sortable: false },
        { key: 'number', label: 'Sale #', sortable: false },
        { key: 'account_name', label: 'Account Name', sortable: false },
        { key: 'account_number', label: 'Account #', sortable: false },
        { key: 'amount', label: 'Initiated Amount', sortable: false, thStyle: { width: '9%' }, thClass: 'text-right', tdClass: 'text-right', },
        { key: 'recoveries', label: 'Deduction', sortable: false, thStyle: { width: '9%' }, thClass: 'text-right', tdClass: 'text-right', },
        { key: 'net', label: 'Net Pay', sortable: false, thStyle: { width: '9%' }, thClass: 'text-right', tdClass: 'text-right', },
        { key: 'initiatedDate', label: 'Date Initiated', sortable: false },
        { key: 'deposits', label: 'Paid', sortable: false, thStyle: { width: '9%' }, thClass: 'text-right', tdClass: 'text-right',},
        { key: 'paidDate', label: 'Date Paid', sortable: false, },
        { key: 'status', label: 'Status', sortable: false },
        { key: 'bank', label: 'Paid From', sortable: false, },
    ]

    const from = ref(0)
    const to = ref(0)
    const meta = ref({ from: 0, to: 0, total: 0 })
    const perPage = ref(10)
    const totalRecords = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [5, 10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('updated_at')
    const isSortDirDesc = ref(true)

    const bank_id = ref(null)
    const currency_id = ref(null)
    const location_id = ref(null)
    const administrativeFilter = ref(null)

    const refetch = () => {
        records.value.refresh()
    }

    watch([currentPage, perPage, searchQuery, sortBy, isSortDirDesc, bank_id, currency_id, location_id], () => {
        refetch()
    })

    const fetch = (ctx, callback) => {
        store
            .dispatch('cromis-payments/list', {
                bank_id: bank_id.value,
                currency_id: currency_id.value,
                location_id: location_id.value,
                query: searchQuery.value,
                per_page: perPage.value,
                page: currentPage.value,
                sortBy: sortBy.value,
                sortDesc: isSortDirDesc.value,
            })
            .then(response => {
                const { payments, meta } = response.data

                meta.value = meta

                callback(payments)
                totalRecords.value = meta.value.total
                from.value = meta.value.from
                to.value = meta.value.to
            })
            .catch(() => {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Error fetching payments list',
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                    },
                })
            })
    }

    const resolveStatusVariant = status => {
        if (status === 1) return 'success'
        if (status === 0) return 'secondary'
        return 'warning'
    }

    return {
        fetch,
        columns,
        perPage,
        currentPage,
        totalRecords,
        from,
        to,
        meta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        records,

        // resolveUserRoleVariant,
        // resolveUserRoleIcon,
        resolveStatusVariant,
        refetch,

        // Extra Filters
        // roleFilter,
        // planFilter,
        // statusFilter,
        bank_id,
        currency_id,
        location_id,
    }
}
